// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24Cz2","label":"styles_label__1lyWk"};